<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-link">
  External link:&nbsp;
  <a *scLink="rendering.fields.externalLink"></a>
  <br />
  Internal link:&nbsp;
  <a *scLink="rendering.fields.internalLink">
    <em>HTML</em> or other components can be used within link renderers, for example links to
    images.
    <!--
      IMPORTANT: When using other components as a link body,
      be aware that when using Experience Editor to edit the link,
      it will render differently than it will in normal or preview modes.
      Due to technical limitations, it will render like:
      <span class="sc-link-wrapper">
        <a href="#">this link is editable</a>
      </span>
      <a href="#">Link body components</a>

      When not editing, the same component would render as:
      <a href="#">Link body components</a>
    -->
  </a>
  <br />
  Email link:&nbsp;
  <a *scLink="rendering.fields.emailLink"></a>
  <br />
  All possible content params link:&nbsp;
  <a *scLink="rendering.fields.paramsLink"></a>
  <br />
  The link component accepts params of its own:&nbsp;
  <a *scLink="rendering.fields.externalLink; attrs: linkDynamicAttributes"
    class="fw-bold"
    data-otherattributes="pass-through-to-anchor-tag"
  ></a>
  <br />
  Link using Angular routing for the target:
  <a *scRouterLink="rendering.fields.internalLink">Router link to /</a>

  Link using both internal and Angular routing links for the target:
  <a *scGenericLink="rendering.fields.internalLink">Generic internal link</a>
  <a *scGenericLink="rendering.fields.externalLink">Generic external link </a>
  <a *scGenericLink="rendering.fields.emailLink">Generic email link</a>
  <a *scGenericLink="rendering.fields.paramsLink">Generic parameterized link</a>
</app-styleguide-specimen>
